var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slice text-with-image"},[_c('prismic-image',{staticClass:"image",class:{
            'is-pulled-left': _vm.slice.primary.image_alignment === 'Left',
            'is-pulled-right': _vm.slice.primary.image_alignment === 'Right',
        },attrs:{"field":_vm.slice.primary.image}}),_c('prismic-rich-text',{staticClass:"content is-clearfix",attrs:{"field":_vm.slice.primary.text_content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }